import React, { useState , useEffect} from "react";
import { Layout, Typography, Button, Row, Col, Space } from 'antd';
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import string from "../../constants/constants";
import { componentStyles } from "./LimitTrialPageStyles";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { getScriptStatus } from "../../api/password";  
import { isNull } from "lodash";
import "./LimitTrialPageStyles.css"


function LimitTrialPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [gettingToKnowScriptStatus, setGettingToKnowScriptStatus] = useState(false);
  const [responseLoading, setResponseLoading] = useState(true);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  
  useEffect(() => {
    checkGettingToKnowYouScriptStatus();
  }, []);

  const checkGettingToKnowYouScriptStatus = async () => {
    try {
      const response = await getScriptStatus();
      if (!isNull(response.conversation)) {
        response?.conversationCompleted && setGettingToKnowScriptStatus(true);
        setResponseLoading(true);
      } else {
        setGettingToKnowScriptStatus(false);
        setResponseLoading(true);
      }
    } catch (err) {
      console.log("In catch", err);
    }
  };

  const { Content } = Layout;
  const { Text } = Typography;

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const navigate = useNavigate();

  const handleConversationButtonClick = () => {
    gettingToKnowScriptStatus
      ? navigate("/conversation?type=openConversation")
      : navigate("/conversation?type=gettingToKnowYou");
  };

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  return (
    <div style={{minHeight: "100dvh" , overflow: "hidden"}} className="setEndBackground">
      
        <Content className="content">
          <Row justify="left" align="" className="main-row">
            <Col span={24} className="text-col">
              <h1 style={componentStyles.titleStyle}>
                      {string.limitPageHeader}
                    </h1>
              <Text className="text-para-style">
              To access unlimited conversation time with Amy/arthur, upgrade your
               subscription now. If you are not quite sure you’re ready to commit to a
                subscription yet, you still have 4 days left on your free trial.
              </Text>
              <br />
              <Space className="buttons">

              <Button onClick={handleConversationButtonClick} style={componentStyles.button3} className="limit-width-button">View Subscription Options</Button>
                <RouterLink
                  to="/landing-page"
                  style={{ textDecoration: "none" }}
                >
               <Button style={componentStyles.button2}>
                    {string.returnToHome}
                  </Button>
                </RouterLink> 
                </Space>
            </Col>
          </Row>
        </Content> 
      
    </div>
  );
}

export default LimitTrialPage;
